import { NgModule } from '@angular/core';
import { EditorModule } from '@tinymce/tinymce-angular';
import { FrameEditorComponent } from './components/frame-editor/frame-editor.component';
import { ReadonlyFrameEditorComponent } from './components/readonly-frame-editor/readonly-frame-editor.component';
import { RenameAttachmentPopupComponent } from './components/rename-attachment-popup/rename-attachment-popup.component';
import { FrameEditorBlobService } from './services/frame-editor-blob.service';
import { FrameEditorContextMenuService } from './services/frame-editor-context-menu.service';
import { FrameEditorFileService } from './services/frame-editor-file.service';
import { FrameEditorMediaService } from './services/frame-editor-media-service';
import { FrameEditorContextMenuActionsService } from './services/frame-editor-context-menu-actions.service';
import { FrameEditorRenderHtmlService } from './services/frame-editor-render-html.service';
import { FrameEditorService } from './services/frame-editor.service';
import { SharedBarModule } from '../../components/shared-bar.module';
import { FrameEditorDiffHtmlService } from './services/frame-editor-diff-html.service';

const components = [FrameEditorComponent, ReadonlyFrameEditorComponent, RenameAttachmentPopupComponent];

const modules = [EditorModule, SharedBarModule];

@NgModule({
  declarations: components,
  imports: modules,
  providers: [
    FrameEditorBlobService,
    FrameEditorContextMenuService,
    FrameEditorFileService,
    FrameEditorMediaService,
    FrameEditorContextMenuActionsService,
    FrameEditorRenderHtmlService,
    FrameEditorService,
    FrameEditorDiffHtmlService,
  ],
  exports: [...modules, ...components],
})
export class FrameEditorModule {}
